import { Box } from "@mui/material";
import type { FC, ReactNode } from "react";
import { NEUTRAL, SHADOW, SURFACE } from "../../../theme/tokens";

type FilterRailFrameProps = {
	/** A `FilterSidebar` with `frame="flush"`. */
	rail: ReactNode;
	children: ReactNode;
	/** Drop the frame's shadow when it already sits on a raised card. */
	flat?: boolean;
	/** A fixed height (px) for a frame inside a page section; omit to fill the parent's height. */
	height?: number;
	dataTestId?: string;
};

/** A filter rail and the table it drives as one framed surface. */
// DEFAULT: flat=false — a frame standing on the page background carries the panel shadow.
export const FilterRailFrame: FC<FilterRailFrameProps> = ({ rail, children, flat = false, height, dataTestId }) => (
	<Box
		data-testid={dataTestId}
		sx={{
			display: "flex",
			...(height === undefined ? { flex: 1, minHeight: 0 } : { height }),
			alignItems: "stretch",
			backgroundColor: SURFACE,
			border: `1px solid ${NEUTRAL[200]}`,
			borderRadius: 1,
			boxShadow: flat ? "none" : SHADOW.PANEL_SOFT,
			overflow: "hidden",
		}}
	>
		{rail}
		<Box sx={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0, minHeight: 0 }}>{children}</Box>
	</Box>
);
